import { useTranslation } from 'react-i18next'
import { SectionPlaceholderIcon } from '@/components/ui/SectionPlaceholderIcon'

export function ReportsPlaceholder() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center rounded-xl border border-dashed border-[var(--stryzh-color-border-default)] bg-[var(--stryzh-color-surface)] p-12 text-center">
      <SectionPlaceholderIcon className="mb-3 h-10 w-10 text-[var(--stryzh-color-text-secondary)] opacity-80" />
      <h1 className="text-xl font-medium">{t('nav.reports')}</h1>
      <p className="mt-2 text-[var(--stryzh-color-text-secondary)]">{t('common.soon')}</p>
    </div>
  )
}
